import { useTranslate } from 'react-polyglot';
import { observer } from 'mobx-react';

import { Button } from '@genially/design-system';

import { PlayersList } from '../../../../../../../../shared/application/components/PlayersList/PlayersList';
import { useHostGameContext } from '../../HostGame.context';
import { Sidebar } from '../Sidebar/Sidebar';
import {
  EmptyText,
  IconWrapper,
  StyledBiggerSubtitle,
  StyledSuccessIcon,
  Wrapper,
} from './HandQueueSidebar.styled';

interface HandQueueSidebarProps {
  isOpen: boolean;
  onClose: () => void;
}

export const HandQueueSidebar = observer(({ isOpen, onClose }: HandQueueSidebarProps) => {
  const t = useTranslate();
  const { handQueue } = useHostGameContext();

  const handleDismissAllClick = () => {
    handQueue.dismissAll();
  };

  return (
    <Sidebar isOpen={isOpen} onClose={onClose}>
      <Wrapper>
        <StyledBiggerSubtitle>
          {t('__new.play.view.somebodyHandsUp')}
        </StyledBiggerSubtitle>

        {handQueue.queue.length > 0 && (
          <Button
            width="100%"
            variant={Button.Variant.ACTION}
            onClick={handleDismissAllClick}
          >
            {t('__new.play.view.hostHandsDown')}
          </Button>
        )}

        {handQueue.queue.length === 0 ? (
          <EmptyText>{t('__new.play.view.nobodyHandsUp')}</EmptyText>
        ) : (
          <PlayersList
            players={handQueue.queue}
            Icon={
              <IconWrapper>
                <StyledSuccessIcon />
              </IconWrapper>
            }
            onPlayerClick={player => handQueue.dismiss(player.id)}
            playerWidthFull
            forcedPlayerSize={PlayersList.PlayerSize.Small}
          />
        )}
      </Wrapper>
    </Sidebar>
  );
});
